// @formatter:off
/**
 * Kita-Scheduler
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
// noinspection ES6UnusedImports
import {HttpClient, HttpContext, HttpEvent, HttpParams, HttpResponse} from '@angular/common/http';
import {Inject, Injectable, Optional} from '@angular/core';
import type {AngestellteResourceGetAnstellungenAnstellungParameter} from '@dv/shared/backend/model/angestellte-resource-get-anstellungen-anstellung-parameter';
import type {BackendLocalDate} from '@dv/shared/backend/model/backend-local-date';
import type {BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter} from '@dv/shared/backend/model/bring-abhol-zeiten-communication-resource-get-bring-abholzeiten-state-kinder-ort-id-matrix-parameter';
import type {EntityId} from '@dv/shared/backend/model/entity-id';
import type {FakeSet} from '@dv/shared/backend/model/fake-set';
import type {JaxAustritt} from '@dv/shared/backend/model/jax-austritt';
import type {JaxBelegung} from '@dv/shared/backend/model/jax-belegung';
import type {JaxBelegungMaxGueltigkeit} from '@dv/shared/backend/model/jax-belegung-max-gueltigkeit';
import type {JaxBelegungenWithFraktionen} from '@dv/shared/backend/model/jax-belegungen-with-fraktionen';
import type {JaxBetreuungsGutschein} from '@dv/shared/backend/model/jax-betreuungs-gutschein';
import type {JaxBetreuungsGutscheineGroups} from '@dv/shared/backend/model/jax-betreuungs-gutscheine-groups';
import type {JaxBetreuungsfaktor} from '@dv/shared/backend/model/jax-betreuungsfaktor';
import type {JaxBetreuungsfaktoren} from '@dv/shared/backend/model/jax-betreuungsfaktoren';
import type {JaxBewerbung} from '@dv/shared/backend/model/jax-bewerbung';
import type {JaxBewerbungen} from '@dv/shared/backend/model/jax-bewerbungen';
import type {JaxIds} from '@dv/shared/backend/model/jax-ids';
import type {JaxKind} from '@dv/shared/backend/model/jax-kind';
import type {JaxKinder} from '@dv/shared/backend/model/jax-kinder';
import type {JaxLeistungsrechnungen} from '@dv/shared/backend/model/jax-leistungsrechnungen';
import type {JaxLimitedAdressen} from '@dv/shared/backend/model/jax-limited-adressen';
import type {JaxLocalDate} from '@dv/shared/backend/model/jax-local-date';
import type {JaxMonatsBelegung} from '@dv/shared/backend/model/jax-monats-belegung';
import type {JaxPageContainerJaxKindWochenBelegung} from '@dv/shared/backend/model/jax-page-container-jax-kind-wochen-belegung';
import type {JaxPageContainerJaxKontaktpersonInfo} from '@dv/shared/backend/model/jax-page-container-jax-kontaktperson-info';
import type {JaxPageContainerJaxRechnung} from '@dv/shared/backend/model/jax-page-container-jax-rechnung';
import type {JaxRechnungsAufteilungen} from '@dv/shared/backend/model/jax-rechnungs-aufteilungen';
import type {JaxRelationshipWithKontaktperson} from '@dv/shared/backend/model/jax-relationship-with-kontaktperson';
import type {JaxRelationshipsWithKontaktpersonen} from '@dv/shared/backend/model/jax-relationships-with-kontaktpersonen';
import type {JaxStundenKontingente} from '@dv/shared/backend/model/jax-stunden-kontingente';
import type {JaxTarifParameterHistoryEntries} from '@dv/shared/backend/model/jax-tarif-parameter-history-entries';
import type {JaxTarifParameterHistoryEntry} from '@dv/shared/backend/model/jax-tarif-parameter-history-entry';
import type {JaxTempBlob} from '@dv/shared/backend/model/jax-temp-blob';
import type {KinderResourceDeleteKindKindIdMatrixParameter} from '@dv/shared/backend/model/kinder-resource-delete-kind-kind-id-matrix-parameter';
import type {KinderResourceGetBetreuungsfaktorKinderOrtIdMatrixParameter} from '@dv/shared/backend/model/kinder-resource-get-betreuungsfaktor-kinder-ort-id-matrix-parameter';
import type {KinderResourceGetTarifParameterHistoryEntryParameterParameter} from '@dv/shared/backend/model/kinder-resource-get-tarif-parameter-history-entry-parameter-parameter';
import type {KinderResourceImportAnhangTempBlobIdMatrixParameter} from '@dv/shared/backend/model/kinder-resource-import-anhang-temp-blob-id-matrix-parameter';
import {Observable} from 'rxjs';
import {BaseService} from '../api.base.service';
import {Configuration} from '../configuration';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS} from '../variables';

export interface KinderApiAddGeschwisterRequestParams {
    geschwisterId: EntityId;
    kindId: EntityId;
}

export interface KinderApiAustrittRequestParams {
    kindId: EntityId;
    jaxAustritt: JaxAustritt;
}

export interface KinderApiChangeAnhangConfLevelRequestParams {
    anhangId: EntityId;
    anhangIdMatrix: KinderResourceImportAnhangTempBlobIdMatrixParameter;
    kindId: EntityId;
}

export interface KinderApiCreateBelegungRequestParams {
    kindId: EntityId;
    jaxBelegung: JaxBelegung;
}

export interface KinderApiCreateBewerbungRequestParams {
    kindId: EntityId;
    jaxBewerbung: JaxBewerbung;
}

export interface KinderApiCreateKindRequestParams {
    jaxKind: JaxKind;
}

export interface KinderApiCreateOrUpdateBetreuungsGutscheinRequestParams {
    kindId: EntityId;
    jaxBetreuungsGutschein: JaxBetreuungsGutschein;
}

export interface KinderApiCreateTarifParameterHistoryEntryRequestParams {
    kindId: EntityId;
    jaxTarifParameterHistoryEntry: JaxTarifParameterHistoryEntry;
}

export interface KinderApiDeleteAdresseRequestParams {
    id: EntityId;
    kindId: EntityId;
}

export interface KinderApiDeleteAnhangRequestParams {
    id: EntityId;
    kindId: EntityId;
}

export interface KinderApiDeleteKindRequestParams {
    kindId: EntityId;
    kindIdMatrix: KinderResourceDeleteKindKindIdMatrixParameter;
}

export interface KinderApiDeleteTarifParameterHistoryEntryRequestParams {
    entryId: EntityId;
    kindId: EntityId;
}

export interface KinderApiExtendTarifParameterHistoryEntryGueltigkeitRequestParams {
    entryId: EntityId;
    kindId: EntityId;
}

export interface KinderApiGetAdressenRequestParams {
    kindId: EntityId;
}

export interface KinderApiGetAllRequestParams {
    kinder: AngestellteResourceGetAnstellungenAnstellungParameter;
}

export interface KinderApiGetAllRelationshipsWithKontaktpersonenRequestParams {
    kindId: EntityId;
    kontakte: AngestellteResourceGetAnstellungenAnstellungParameter;
}

export interface KinderApiGetAnhangByIdRequestParams {
    anhangId: EntityId;
    kindId: EntityId;
}

export interface KinderApiGetBelegungenWithFraktionenRequestParams {
    belegungenwithfraktionen: BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter;
    kindId: EntityId;
}

export interface KinderApiGetBetreuungsGruendeIdsRequestParams {
    kindId: EntityId;
}

export interface KinderApiGetBetreuungsGutscheineRequestParams {
    kindId: EntityId;
}

export interface KinderApiGetBetreuungsfaktorRequestParams {
    kindId: EntityId;
    kinderOrtId: EntityId;
    kinderOrtIdMatrix: KinderResourceGetBetreuungsfaktorKinderOrtIdMatrixParameter;
}

export interface KinderApiGetBetreuungsfaktorenRequestParams {
    betreuungsfaktoren: KinderResourceGetBetreuungsfaktorKinderOrtIdMatrixParameter;
    kindId: EntityId;
}

export interface KinderApiGetBewerbungenRequestParams {
    bewerbungen: AngestellteResourceGetAnstellungenAnstellungParameter;
    kindId: EntityId;
}

export interface KinderApiGetKindByIdRequestParams {
    kindId: EntityId;
    kindIdMatrix: BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter;
}

export interface KinderApiGetKontaktOverviewRequestParams {
    kindId: EntityId;
}

export interface KinderApiGetLeistungsrechnungenRequestParams {
    kindId: EntityId;
    leistungsrechnungen: BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter;
}

export interface KinderApiGetMatchingKindRequestParams {
    jaxKind: JaxKind;
}

export interface KinderApiGetMaxGueltigBisForNewBelegungRequestParams {
    kindId: EntityId;
    jaxBelegung: JaxBelegung;
}

export interface KinderApiGetOffeneBewerbungRequestParams {
    kindId: EntityId;
    offen: AngestellteResourceGetAnstellungenAnstellungParameter;
}

export interface KinderApiGetRechnungenByKindIDRequestParams {
    kindId: EntityId;
    rechnungen: BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter;
}

export interface KinderApiGetRechnungsaufteilungRequestParams {
    kindId: EntityId;
}

export interface KinderApiGetRelationshipWithKontaktpersonRequestParams {
    kindId: EntityId;
    kontaktpersonId: EntityId;
    kontaktpersonIdMatrix: AngestellteResourceGetAnstellungenAnstellungParameter;
}

export interface KinderApiGetStundenKontingenteRequestParams {
    kindId: EntityId;
}

export interface KinderApiGetTarifParameterHistoryEntryRequestParams {
    kindId: EntityId;
    parameter: KinderResourceGetTarifParameterHistoryEntryParameterParameter;
}

export interface KinderApiGetWochenBelegungenRequestParams {
    kindId: EntityId;
    wochenbelegungen: BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter;
}

export interface KinderApiImportAnhangRequestParams {
    kindId: EntityId;
    tempBlobId: EntityId;
    tempBlobIdMatrix: KinderResourceImportAnhangTempBlobIdMatrixParameter;
}

export interface KinderApiRemoveGeschwisterRequestParams {
    geschwisterId: EntityId;
    kindId: EntityId;
}

export interface KinderApiRevertAustrittRequestParams {
    austrittsDatum: BackendLocalDate;
    kindId: EntityId;
}

export interface KinderApiSetBetreuungsGruendeRequestParams {
    kindId: EntityId;
    requestBody: FakeSet<string>;
}

export interface KinderApiTerminateTarifParameterHistoryEntryRequestParams {
    kindId: EntityId;
    jaxLocalDate: JaxLocalDate;
}

export interface KinderApiUpdateKindRequestParams {
    kindId: EntityId;
    jaxKind: JaxKind;
}

export interface KinderApiUpdateMonatsBelegungRequestParams {
    kindId: EntityId;
    jaxMonatsBelegung: JaxMonatsBelegung;
}

export interface KinderApiUpdateRechnungsaufteilungRequestParams {
    kindId: EntityId;
    jaxRechnungsAufteilungen: JaxRechnungsAufteilungen;
}

export interface KinderApiValidateNewBelegungRequestParams {
    kindId: EntityId;
    jaxBelegung: JaxBelegung;
}

@Injectable({
  providedIn: 'root'
})
export class KinderApi extends BaseService {

    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string|string[],
        @Optional() configuration?: Configuration,
    ) {
        super(basePath, configuration);
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public addGeschwister$(requestParameters: KinderApiAddGeschwisterRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public addGeschwister$(requestParameters: KinderApiAddGeschwisterRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public addGeschwister$(requestParameters: KinderApiAddGeschwisterRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public addGeschwister$(requestParameters: KinderApiAddGeschwisterRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const geschwisterId = requestParameters.geschwisterId;
        if (geschwisterId === null || geschwisterId === undefined) {
            throw new Error('Required parameter geschwisterId was null or undefined when calling addGeschwister$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling addGeschwister$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/geschwister/${this.configuration.encodeParam({name: "geschwisterId", value: geschwisterId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public austritt$(requestParameters: KinderApiAustrittRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public austritt$(requestParameters: KinderApiAustrittRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public austritt$(requestParameters: KinderApiAustrittRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public austritt$(requestParameters: KinderApiAustrittRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling austritt$.');
        }
        const jaxAustritt = requestParameters.jaxAustritt;
        if (jaxAustritt === null || jaxAustritt === undefined) {
            throw new Error('Required parameter jaxAustritt was null or undefined when calling austritt$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/austritt`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxAustritt,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public changeAnhangConfLevel$(requestParameters: KinderApiChangeAnhangConfLevelRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public changeAnhangConfLevel$(requestParameters: KinderApiChangeAnhangConfLevelRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public changeAnhangConfLevel$(requestParameters: KinderApiChangeAnhangConfLevelRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public changeAnhangConfLevel$(requestParameters: KinderApiChangeAnhangConfLevelRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const anhangId = requestParameters.anhangId;
        if (anhangId === null || anhangId === undefined) {
            throw new Error('Required parameter anhangId was null or undefined when calling changeAnhangConfLevel$.');
        }
        const anhangIdMatrix = requestParameters.anhangIdMatrix;
        if (anhangIdMatrix === null || anhangIdMatrix === undefined) {
            throw new Error('Required parameter anhangIdMatrix was null or undefined when calling changeAnhangConfLevel$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling changeAnhangConfLevel$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/anhaenge/${this.configuration.encodeParam({name: "anhangId", value: anhangId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "anhangIdMatrix", value: anhangIdMatrix, in: "path", style: "matrix", explode: true, dataType: "KinderResourceImportAnhangTempBlobIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public createBelegung$(requestParameters: KinderApiCreateBelegungRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public createBelegung$(requestParameters: KinderApiCreateBelegungRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public createBelegung$(requestParameters: KinderApiCreateBelegungRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public createBelegung$(requestParameters: KinderApiCreateBelegungRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling createBelegung$.');
        }
        const jaxBelegung = requestParameters.jaxBelegung;
        if (jaxBelegung === null || jaxBelegung === undefined) {
            throw new Error('Required parameter jaxBelegung was null or undefined when calling createBelegung$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/belegungen`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxBelegung,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public createBewerbung$(requestParameters: KinderApiCreateBewerbungRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public createBewerbung$(requestParameters: KinderApiCreateBewerbungRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public createBewerbung$(requestParameters: KinderApiCreateBewerbungRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public createBewerbung$(requestParameters: KinderApiCreateBewerbungRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling createBewerbung$.');
        }
        const jaxBewerbung = requestParameters.jaxBewerbung;
        if (jaxBewerbung === null || jaxBewerbung === undefined) {
            throw new Error('Required parameter jaxBewerbung was null or undefined when calling createBewerbung$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/bewerbungen`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxBewerbung,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public createKind$(requestParameters: KinderApiCreateKindRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public createKind$(requestParameters: KinderApiCreateKindRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public createKind$(requestParameters: KinderApiCreateKindRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public createKind$(requestParameters: KinderApiCreateKindRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const jaxKind = requestParameters.jaxKind;
        if (jaxKind === null || jaxKind === undefined) {
            throw new Error('Required parameter jaxKind was null or undefined when calling createKind$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxKind,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public createOrUpdateBetreuungsGutschein$(requestParameters: KinderApiCreateOrUpdateBetreuungsGutscheinRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public createOrUpdateBetreuungsGutschein$(requestParameters: KinderApiCreateOrUpdateBetreuungsGutscheinRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public createOrUpdateBetreuungsGutschein$(requestParameters: KinderApiCreateOrUpdateBetreuungsGutscheinRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public createOrUpdateBetreuungsGutschein$(requestParameters: KinderApiCreateOrUpdateBetreuungsGutscheinRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling createOrUpdateBetreuungsGutschein$.');
        }
        const jaxBetreuungsGutschein = requestParameters.jaxBetreuungsGutschein;
        if (jaxBetreuungsGutschein === null || jaxBetreuungsGutschein === undefined) {
            throw new Error('Required parameter jaxBetreuungsGutschein was null or undefined when calling createOrUpdateBetreuungsGutschein$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/betreuungsgutscheine`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxBetreuungsGutschein,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public createTarifParameterHistoryEntry$(requestParameters: KinderApiCreateTarifParameterHistoryEntryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public createTarifParameterHistoryEntry$(requestParameters: KinderApiCreateTarifParameterHistoryEntryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public createTarifParameterHistoryEntry$(requestParameters: KinderApiCreateTarifParameterHistoryEntryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public createTarifParameterHistoryEntry$(requestParameters: KinderApiCreateTarifParameterHistoryEntryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling createTarifParameterHistoryEntry$.');
        }
        const jaxTarifParameterHistoryEntry = requestParameters.jaxTarifParameterHistoryEntry;
        if (jaxTarifParameterHistoryEntry === null || jaxTarifParameterHistoryEntry === undefined) {
            throw new Error('Required parameter jaxTarifParameterHistoryEntry was null or undefined when calling createTarifParameterHistoryEntry$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/tarife/parameter`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxTarifParameterHistoryEntry,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public deleteAdresse$(requestParameters: KinderApiDeleteAdresseRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteAdresse$(requestParameters: KinderApiDeleteAdresseRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteAdresse$(requestParameters: KinderApiDeleteAdresseRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteAdresse$(requestParameters: KinderApiDeleteAdresseRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteAdresse$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling deleteAdresse$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/adressen/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public deleteAnhang$(requestParameters: KinderApiDeleteAnhangRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteAnhang$(requestParameters: KinderApiDeleteAnhangRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteAnhang$(requestParameters: KinderApiDeleteAnhangRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteAnhang$(requestParameters: KinderApiDeleteAnhangRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const id = requestParameters.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteAnhang$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling deleteAnhang$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/anhaenge/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public deleteKind$(requestParameters: KinderApiDeleteKindRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteKind$(requestParameters: KinderApiDeleteKindRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteKind$(requestParameters: KinderApiDeleteKindRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteKind$(requestParameters: KinderApiDeleteKindRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling deleteKind$.');
        }
        const kindIdMatrix = requestParameters.kindIdMatrix;
        if (kindIdMatrix === null || kindIdMatrix === undefined) {
            throw new Error('Required parameter kindIdMatrix was null or undefined when calling deleteKind$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kindIdMatrix", value: kindIdMatrix, in: "path", style: "matrix", explode: true, dataType: "KinderResourceDeleteKindKindIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public deleteTarifParameterHistoryEntry$(requestParameters: KinderApiDeleteTarifParameterHistoryEntryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteTarifParameterHistoryEntry$(requestParameters: KinderApiDeleteTarifParameterHistoryEntryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteTarifParameterHistoryEntry$(requestParameters: KinderApiDeleteTarifParameterHistoryEntryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteTarifParameterHistoryEntry$(requestParameters: KinderApiDeleteTarifParameterHistoryEntryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const entryId = requestParameters.entryId;
        if (entryId === null || entryId === undefined) {
            throw new Error('Required parameter entryId was null or undefined when calling deleteTarifParameterHistoryEntry$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling deleteTarifParameterHistoryEntry$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/tarife/parameter/${this.configuration.encodeParam({name: "entryId", value: entryId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public extendTarifParameterHistoryEntryGueltigkeit$(requestParameters: KinderApiExtendTarifParameterHistoryEntryGueltigkeitRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public extendTarifParameterHistoryEntryGueltigkeit$(requestParameters: KinderApiExtendTarifParameterHistoryEntryGueltigkeitRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public extendTarifParameterHistoryEntryGueltigkeit$(requestParameters: KinderApiExtendTarifParameterHistoryEntryGueltigkeitRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public extendTarifParameterHistoryEntryGueltigkeit$(requestParameters: KinderApiExtendTarifParameterHistoryEntryGueltigkeitRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const entryId = requestParameters.entryId;
        if (entryId === null || entryId === undefined) {
            throw new Error('Required parameter entryId was null or undefined when calling extendTarifParameterHistoryEntryGueltigkeit$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling extendTarifParameterHistoryEntryGueltigkeit$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/tarife/parameter/${this.configuration.encodeParam({name: "entryId", value: entryId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/gueltigbis`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getAdressen$(requestParameters: KinderApiGetAdressenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxLimitedAdressen>;
    public getAdressen$(requestParameters: KinderApiGetAdressenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxLimitedAdressen>>;
    public getAdressen$(requestParameters: KinderApiGetAdressenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxLimitedAdressen>>;
    public getAdressen$(requestParameters: KinderApiGetAdressenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getAdressen$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/adressen`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxLimitedAdressen>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getAll$(requestParameters: KinderApiGetAllRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxKinder>;
    public getAll$(requestParameters: KinderApiGetAllRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxKinder>>;
    public getAll$(requestParameters: KinderApiGetAllRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxKinder>>;
    public getAll$(requestParameters: KinderApiGetAllRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kinder = requestParameters.kinder;
        if (kinder === null || kinder === undefined) {
            throw new Error('Required parameter kinder was null or undefined when calling getAll$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder${this.configuration.encodeParam({name: "kinder", value: kinder, in: "path", style: "matrix", explode: true, dataType: "AngestellteResourceGetAnstellungenAnstellungParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxKinder>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getAllRelationshipsWithKontaktpersonen$(requestParameters: KinderApiGetAllRelationshipsWithKontaktpersonenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxRelationshipsWithKontaktpersonen>;
    public getAllRelationshipsWithKontaktpersonen$(requestParameters: KinderApiGetAllRelationshipsWithKontaktpersonenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxRelationshipsWithKontaktpersonen>>;
    public getAllRelationshipsWithKontaktpersonen$(requestParameters: KinderApiGetAllRelationshipsWithKontaktpersonenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxRelationshipsWithKontaktpersonen>>;
    public getAllRelationshipsWithKontaktpersonen$(requestParameters: KinderApiGetAllRelationshipsWithKontaktpersonenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getAllRelationshipsWithKontaktpersonen$.');
        }
        const kontakte = requestParameters.kontakte;
        if (kontakte === null || kontakte === undefined) {
            throw new Error('Required parameter kontakte was null or undefined when calling getAllRelationshipsWithKontaktpersonen$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/kontakte${this.configuration.encodeParam({name: "kontakte", value: kontakte, in: "path", style: "matrix", explode: true, dataType: "AngestellteResourceGetAnstellungenAnstellungParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxRelationshipsWithKontaktpersonen>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getAnhangById$(requestParameters: KinderApiGetAnhangByIdRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTempBlob>;
    public getAnhangById$(requestParameters: KinderApiGetAnhangByIdRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTempBlob>>;
    public getAnhangById$(requestParameters: KinderApiGetAnhangByIdRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTempBlob>>;
    public getAnhangById$(requestParameters: KinderApiGetAnhangByIdRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const anhangId = requestParameters.anhangId;
        if (anhangId === null || anhangId === undefined) {
            throw new Error('Required parameter anhangId was null or undefined when calling getAnhangById$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getAnhangById$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/anhaenge/${this.configuration.encodeParam({name: "anhangId", value: anhangId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTempBlob>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBelegungenWithFraktionen$(requestParameters: KinderApiGetBelegungenWithFraktionenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxBelegungenWithFraktionen>;
    public getBelegungenWithFraktionen$(requestParameters: KinderApiGetBelegungenWithFraktionenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxBelegungenWithFraktionen>>;
    public getBelegungenWithFraktionen$(requestParameters: KinderApiGetBelegungenWithFraktionenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxBelegungenWithFraktionen>>;
    public getBelegungenWithFraktionen$(requestParameters: KinderApiGetBelegungenWithFraktionenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const belegungenwithfraktionen = requestParameters.belegungenwithfraktionen;
        if (belegungenwithfraktionen === null || belegungenwithfraktionen === undefined) {
            throw new Error('Required parameter belegungenwithfraktionen was null or undefined when calling getBelegungenWithFraktionen$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getBelegungenWithFraktionen$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/belegungenwithfraktionen${this.configuration.encodeParam({name: "belegungenwithfraktionen", value: belegungenwithfraktionen, in: "path", style: "matrix", explode: true, dataType: "BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxBelegungenWithFraktionen>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBetreuungsGruendeIds$(requestParameters: KinderApiGetBetreuungsGruendeIdsRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxIds>;
    public getBetreuungsGruendeIds$(requestParameters: KinderApiGetBetreuungsGruendeIdsRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxIds>>;
    public getBetreuungsGruendeIds$(requestParameters: KinderApiGetBetreuungsGruendeIdsRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxIds>>;
    public getBetreuungsGruendeIds$(requestParameters: KinderApiGetBetreuungsGruendeIdsRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getBetreuungsGruendeIds$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/betreuungsgruende`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxIds>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBetreuungsGutscheine$(requestParameters: KinderApiGetBetreuungsGutscheineRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxBetreuungsGutscheineGroups>;
    public getBetreuungsGutscheine$(requestParameters: KinderApiGetBetreuungsGutscheineRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxBetreuungsGutscheineGroups>>;
    public getBetreuungsGutscheine$(requestParameters: KinderApiGetBetreuungsGutscheineRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxBetreuungsGutscheineGroups>>;
    public getBetreuungsGutscheine$(requestParameters: KinderApiGetBetreuungsGutscheineRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getBetreuungsGutscheine$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/betreuungsgutscheine`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxBetreuungsGutscheineGroups>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBetreuungsfaktor$(requestParameters: KinderApiGetBetreuungsfaktorRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxBetreuungsfaktor>;
    public getBetreuungsfaktor$(requestParameters: KinderApiGetBetreuungsfaktorRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxBetreuungsfaktor>>;
    public getBetreuungsfaktor$(requestParameters: KinderApiGetBetreuungsfaktorRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxBetreuungsfaktor>>;
    public getBetreuungsfaktor$(requestParameters: KinderApiGetBetreuungsfaktorRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getBetreuungsfaktor$.');
        }
        const kinderOrtId = requestParameters.kinderOrtId;
        if (kinderOrtId === null || kinderOrtId === undefined) {
            throw new Error('Required parameter kinderOrtId was null or undefined when calling getBetreuungsfaktor$.');
        }
        const kinderOrtIdMatrix = requestParameters.kinderOrtIdMatrix;
        if (kinderOrtIdMatrix === null || kinderOrtIdMatrix === undefined) {
            throw new Error('Required parameter kinderOrtIdMatrix was null or undefined when calling getBetreuungsfaktor$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/betreuungsfaktoren/kita/${this.configuration.encodeParam({name: "kinderOrtId", value: kinderOrtId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kinderOrtIdMatrix", value: kinderOrtIdMatrix, in: "path", style: "matrix", explode: true, dataType: "KinderResourceGetBetreuungsfaktorKinderOrtIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxBetreuungsfaktor>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBetreuungsfaktoren$(requestParameters: KinderApiGetBetreuungsfaktorenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxBetreuungsfaktoren>;
    public getBetreuungsfaktoren$(requestParameters: KinderApiGetBetreuungsfaktorenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxBetreuungsfaktoren>>;
    public getBetreuungsfaktoren$(requestParameters: KinderApiGetBetreuungsfaktorenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxBetreuungsfaktoren>>;
    public getBetreuungsfaktoren$(requestParameters: KinderApiGetBetreuungsfaktorenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const betreuungsfaktoren = requestParameters.betreuungsfaktoren;
        if (betreuungsfaktoren === null || betreuungsfaktoren === undefined) {
            throw new Error('Required parameter betreuungsfaktoren was null or undefined when calling getBetreuungsfaktoren$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getBetreuungsfaktoren$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/betreuungsfaktoren${this.configuration.encodeParam({name: "betreuungsfaktoren", value: betreuungsfaktoren, in: "path", style: "matrix", explode: true, dataType: "KinderResourceGetBetreuungsfaktorKinderOrtIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxBetreuungsfaktoren>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getBewerbungen$(requestParameters: KinderApiGetBewerbungenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxBewerbungen>;
    public getBewerbungen$(requestParameters: KinderApiGetBewerbungenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxBewerbungen>>;
    public getBewerbungen$(requestParameters: KinderApiGetBewerbungenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxBewerbungen>>;
    public getBewerbungen$(requestParameters: KinderApiGetBewerbungenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const bewerbungen = requestParameters.bewerbungen;
        if (bewerbungen === null || bewerbungen === undefined) {
            throw new Error('Required parameter bewerbungen was null or undefined when calling getBewerbungen$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getBewerbungen$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/bewerbungen${this.configuration.encodeParam({name: "bewerbungen", value: bewerbungen, in: "path", style: "matrix", explode: true, dataType: "AngestellteResourceGetAnstellungenAnstellungParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxBewerbungen>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getKindById$(requestParameters: KinderApiGetKindByIdRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxKind>;
    public getKindById$(requestParameters: KinderApiGetKindByIdRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxKind>>;
    public getKindById$(requestParameters: KinderApiGetKindByIdRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxKind>>;
    public getKindById$(requestParameters: KinderApiGetKindByIdRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getKindById$.');
        }
        const kindIdMatrix = requestParameters.kindIdMatrix;
        if (kindIdMatrix === null || kindIdMatrix === undefined) {
            throw new Error('Required parameter kindIdMatrix was null or undefined when calling getKindById$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kindIdMatrix", value: kindIdMatrix, in: "path", style: "matrix", explode: true, dataType: "BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxKind>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getKontaktOverview$(requestParameters: KinderApiGetKontaktOverviewRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxPageContainerJaxKontaktpersonInfo>;
    public getKontaktOverview$(requestParameters: KinderApiGetKontaktOverviewRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxPageContainerJaxKontaktpersonInfo>>;
    public getKontaktOverview$(requestParameters: KinderApiGetKontaktOverviewRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxPageContainerJaxKontaktpersonInfo>>;
    public getKontaktOverview$(requestParameters: KinderApiGetKontaktOverviewRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getKontaktOverview$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/kontaktoverview`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxPageContainerJaxKontaktpersonInfo>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getLeistungsrechnungen$(requestParameters: KinderApiGetLeistungsrechnungenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxLeistungsrechnungen>;
    public getLeistungsrechnungen$(requestParameters: KinderApiGetLeistungsrechnungenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxLeistungsrechnungen>>;
    public getLeistungsrechnungen$(requestParameters: KinderApiGetLeistungsrechnungenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxLeistungsrechnungen>>;
    public getLeistungsrechnungen$(requestParameters: KinderApiGetLeistungsrechnungenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getLeistungsrechnungen$.');
        }
        const leistungsrechnungen = requestParameters.leistungsrechnungen;
        if (leistungsrechnungen === null || leistungsrechnungen === undefined) {
            throw new Error('Required parameter leistungsrechnungen was null or undefined when calling getLeistungsrechnungen$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/leistungsrechnungen${this.configuration.encodeParam({name: "leistungsrechnungen", value: leistungsrechnungen, in: "path", style: "matrix", explode: true, dataType: "BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxLeistungsrechnungen>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getMatchingKind$(requestParameters: KinderApiGetMatchingKindRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<JaxKinder>;
    public getMatchingKind$(requestParameters: KinderApiGetMatchingKindRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxKinder>>;
    public getMatchingKind$(requestParameters: KinderApiGetMatchingKindRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxKinder>>;
    public getMatchingKind$(requestParameters: KinderApiGetMatchingKindRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const jaxKind = requestParameters.jaxKind;
        if (jaxKind === null || jaxKind === undefined) {
            throw new Error('Required parameter jaxKind was null or undefined when calling getMatchingKind$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            '*/*'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/match`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxKinder>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxKind,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getMaxGueltigBisForNewBelegung$(requestParameters: KinderApiGetMaxGueltigBisForNewBelegungRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxBelegungMaxGueltigkeit>;
    public getMaxGueltigBisForNewBelegung$(requestParameters: KinderApiGetMaxGueltigBisForNewBelegungRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxBelegungMaxGueltigkeit>>;
    public getMaxGueltigBisForNewBelegung$(requestParameters: KinderApiGetMaxGueltigBisForNewBelegungRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxBelegungMaxGueltigkeit>>;
    public getMaxGueltigBisForNewBelegung$(requestParameters: KinderApiGetMaxGueltigBisForNewBelegungRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getMaxGueltigBisForNewBelegung$.');
        }
        const jaxBelegung = requestParameters.jaxBelegung;
        if (jaxBelegung === null || jaxBelegung === undefined) {
            throw new Error('Required parameter jaxBelegung was null or undefined when calling getMaxGueltigBisForNewBelegung$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/belegungen/maxgueltigbis`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxBelegungMaxGueltigkeit>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxBelegung,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getOffeneBewerbung$(requestParameters: KinderApiGetOffeneBewerbungRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public getOffeneBewerbung$(requestParameters: KinderApiGetOffeneBewerbungRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public getOffeneBewerbung$(requestParameters: KinderApiGetOffeneBewerbungRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public getOffeneBewerbung$(requestParameters: KinderApiGetOffeneBewerbungRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getOffeneBewerbung$.');
        }
        const offen = requestParameters.offen;
        if (offen === null || offen === undefined) {
            throw new Error('Required parameter offen was null or undefined when calling getOffeneBewerbung$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/bewerbungen/offen${this.configuration.encodeParam({name: "offen", value: offen, in: "path", style: "matrix", explode: true, dataType: "AngestellteResourceGetAnstellungenAnstellungParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getRechnungenByKindID$(requestParameters: KinderApiGetRechnungenByKindIDRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxPageContainerJaxRechnung>;
    public getRechnungenByKindID$(requestParameters: KinderApiGetRechnungenByKindIDRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxPageContainerJaxRechnung>>;
    public getRechnungenByKindID$(requestParameters: KinderApiGetRechnungenByKindIDRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxPageContainerJaxRechnung>>;
    public getRechnungenByKindID$(requestParameters: KinderApiGetRechnungenByKindIDRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getRechnungenByKindID$.');
        }
        const rechnungen = requestParameters.rechnungen;
        if (rechnungen === null || rechnungen === undefined) {
            throw new Error('Required parameter rechnungen was null or undefined when calling getRechnungenByKindID$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/rechnungen${this.configuration.encodeParam({name: "rechnungen", value: rechnungen, in: "path", style: "matrix", explode: true, dataType: "BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxPageContainerJaxRechnung>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getRechnungsaufteilung$(requestParameters: KinderApiGetRechnungsaufteilungRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxRechnungsAufteilungen>;
    public getRechnungsaufteilung$(requestParameters: KinderApiGetRechnungsaufteilungRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxRechnungsAufteilungen>>;
    public getRechnungsaufteilung$(requestParameters: KinderApiGetRechnungsaufteilungRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxRechnungsAufteilungen>>;
    public getRechnungsaufteilung$(requestParameters: KinderApiGetRechnungsaufteilungRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getRechnungsaufteilung$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/rechnungsaufteilung`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxRechnungsAufteilungen>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getRelationshipWithKontaktperson$(requestParameters: KinderApiGetRelationshipWithKontaktpersonRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<JaxRelationshipWithKontaktperson>;
    public getRelationshipWithKontaktperson$(requestParameters: KinderApiGetRelationshipWithKontaktpersonRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxRelationshipWithKontaktperson>>;
    public getRelationshipWithKontaktperson$(requestParameters: KinderApiGetRelationshipWithKontaktpersonRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxRelationshipWithKontaktperson>>;
    public getRelationshipWithKontaktperson$(requestParameters: KinderApiGetRelationshipWithKontaktpersonRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: '*/*', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getRelationshipWithKontaktperson$.');
        }
        const kontaktpersonId = requestParameters.kontaktpersonId;
        if (kontaktpersonId === null || kontaktpersonId === undefined) {
            throw new Error('Required parameter kontaktpersonId was null or undefined when calling getRelationshipWithKontaktperson$.');
        }
        const kontaktpersonIdMatrix = requestParameters.kontaktpersonIdMatrix;
        if (kontaktpersonIdMatrix === null || kontaktpersonIdMatrix === undefined) {
            throw new Error('Required parameter kontaktpersonIdMatrix was null or undefined when calling getRelationshipWithKontaktperson$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            '*/*'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/kontakte/${this.configuration.encodeParam({name: "kontaktpersonId", value: kontaktpersonId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "kontaktpersonIdMatrix", value: kontaktpersonIdMatrix, in: "path", style: "matrix", explode: true, dataType: "AngestellteResourceGetAnstellungenAnstellungParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxRelationshipWithKontaktperson>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getStundenKontingente$(requestParameters: KinderApiGetStundenKontingenteRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxStundenKontingente>;
    public getStundenKontingente$(requestParameters: KinderApiGetStundenKontingenteRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxStundenKontingente>>;
    public getStundenKontingente$(requestParameters: KinderApiGetStundenKontingenteRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxStundenKontingente>>;
    public getStundenKontingente$(requestParameters: KinderApiGetStundenKontingenteRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getStundenKontingente$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/stundenkontingente`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxStundenKontingente>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getTarifParameterHistoryEntry$(requestParameters: KinderApiGetTarifParameterHistoryEntryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxTarifParameterHistoryEntries>;
    public getTarifParameterHistoryEntry$(requestParameters: KinderApiGetTarifParameterHistoryEntryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxTarifParameterHistoryEntries>>;
    public getTarifParameterHistoryEntry$(requestParameters: KinderApiGetTarifParameterHistoryEntryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxTarifParameterHistoryEntries>>;
    public getTarifParameterHistoryEntry$(requestParameters: KinderApiGetTarifParameterHistoryEntryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getTarifParameterHistoryEntry$.');
        }
        const parameter = requestParameters.parameter;
        if (parameter === null || parameter === undefined) {
            throw new Error('Required parameter parameter was null or undefined when calling getTarifParameterHistoryEntry$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/tarife/parameter${this.configuration.encodeParam({name: "parameter", value: parameter, in: "path", style: "matrix", explode: true, dataType: "KinderResourceGetTarifParameterHistoryEntryParameterParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxTarifParameterHistoryEntries>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public getWochenBelegungen$(requestParameters: KinderApiGetWochenBelegungenRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<JaxPageContainerJaxKindWochenBelegung>;
    public getWochenBelegungen$(requestParameters: KinderApiGetWochenBelegungenRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<JaxPageContainerJaxKindWochenBelegung>>;
    public getWochenBelegungen$(requestParameters: KinderApiGetWochenBelegungenRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<JaxPageContainerJaxKindWochenBelegung>>;
    public getWochenBelegungen$(requestParameters: KinderApiGetWochenBelegungenRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling getWochenBelegungen$.');
        }
        const wochenbelegungen = requestParameters.wochenbelegungen;
        if (wochenbelegungen === null || wochenbelegungen === undefined) {
            throw new Error('Required parameter wochenbelegungen was null or undefined when calling getWochenBelegungen$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/wochenbelegungen${this.configuration.encodeParam({name: "wochenbelegungen", value: wochenbelegungen, in: "path", style: "matrix", explode: true, dataType: "BringAbholZeitenCommunicationResourceGetBringAbholzeitenStateKinderOrtIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<JaxPageContainerJaxKindWochenBelegung>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public importAnhang$(requestParameters: KinderApiImportAnhangRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public importAnhang$(requestParameters: KinderApiImportAnhangRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public importAnhang$(requestParameters: KinderApiImportAnhangRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public importAnhang$(requestParameters: KinderApiImportAnhangRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling importAnhang$.');
        }
        const tempBlobId = requestParameters.tempBlobId;
        if (tempBlobId === null || tempBlobId === undefined) {
            throw new Error('Required parameter tempBlobId was null or undefined when calling importAnhang$.');
        }
        const tempBlobIdMatrix = requestParameters.tempBlobIdMatrix;
        if (tempBlobIdMatrix === null || tempBlobIdMatrix === undefined) {
            throw new Error('Required parameter tempBlobIdMatrix was null or undefined when calling importAnhang$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/anhaenge/import-temp-blob/${this.configuration.encodeParam({name: "tempBlobId", value: tempBlobId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}${this.configuration.encodeParam({name: "tempBlobIdMatrix", value: tempBlobIdMatrix, in: "path", style: "matrix", explode: true, dataType: "KinderResourceImportAnhangTempBlobIdMatrixParameter", dataFormat: undefined})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public removeGeschwister$(requestParameters: KinderApiRemoveGeschwisterRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public removeGeschwister$(requestParameters: KinderApiRemoveGeschwisterRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public removeGeschwister$(requestParameters: KinderApiRemoveGeschwisterRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public removeGeschwister$(requestParameters: KinderApiRemoveGeschwisterRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const geschwisterId = requestParameters.geschwisterId;
        if (geschwisterId === null || geschwisterId === undefined) {
            throw new Error('Required parameter geschwisterId was null or undefined when calling removeGeschwister$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling removeGeschwister$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/geschwister/${this.configuration.encodeParam({name: "geschwisterId", value: geschwisterId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public revertAustritt$(requestParameters: KinderApiRevertAustrittRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public revertAustritt$(requestParameters: KinderApiRevertAustrittRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public revertAustritt$(requestParameters: KinderApiRevertAustrittRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public revertAustritt$(requestParameters: KinderApiRevertAustrittRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const austrittsDatum = requestParameters.austrittsDatum;
        if (austrittsDatum === null || austrittsDatum === undefined) {
            throw new Error('Required parameter austrittsDatum was null or undefined when calling revertAustritt$.');
        }
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling revertAustritt$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/austritt/${this.configuration.encodeParam({name: "austrittsDatum", value: austrittsDatum, in: "path", style: "simple", explode: false, dataType: "BackendLocalDate", dataFormat: "date"})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public setBetreuungsGruende$(requestParameters: KinderApiSetBetreuungsGruendeRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public setBetreuungsGruende$(requestParameters: KinderApiSetBetreuungsGruendeRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public setBetreuungsGruende$(requestParameters: KinderApiSetBetreuungsGruendeRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public setBetreuungsGruende$(requestParameters: KinderApiSetBetreuungsGruendeRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling setBetreuungsGruende$.');
        }
        const requestBody = requestParameters.requestBody;
        if (requestBody === null || requestBody === undefined) {
            throw new Error('Required parameter requestBody was null or undefined when calling setBetreuungsGruende$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/betreuungsgruende`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: requestBody,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public terminateTarifParameterHistoryEntry$(requestParameters: KinderApiTerminateTarifParameterHistoryEntryRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public terminateTarifParameterHistoryEntry$(requestParameters: KinderApiTerminateTarifParameterHistoryEntryRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public terminateTarifParameterHistoryEntry$(requestParameters: KinderApiTerminateTarifParameterHistoryEntryRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public terminateTarifParameterHistoryEntry$(requestParameters: KinderApiTerminateTarifParameterHistoryEntryRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling terminateTarifParameterHistoryEntry$.');
        }
        const jaxLocalDate = requestParameters.jaxLocalDate;
        if (jaxLocalDate === null || jaxLocalDate === undefined) {
            throw new Error('Required parameter jaxLocalDate was null or undefined when calling terminateTarifParameterHistoryEntry$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/tarife/parameter/enddate`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxLocalDate,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public updateKind$(requestParameters: KinderApiUpdateKindRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public updateKind$(requestParameters: KinderApiUpdateKindRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public updateKind$(requestParameters: KinderApiUpdateKindRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public updateKind$(requestParameters: KinderApiUpdateKindRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling updateKind$.');
        }
        const jaxKind = requestParameters.jaxKind;
        if (jaxKind === null || jaxKind === undefined) {
            throw new Error('Required parameter jaxKind was null or undefined when calling updateKind$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxKind,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public updateMonatsBelegung$(requestParameters: KinderApiUpdateMonatsBelegungRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public updateMonatsBelegung$(requestParameters: KinderApiUpdateMonatsBelegungRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public updateMonatsBelegung$(requestParameters: KinderApiUpdateMonatsBelegungRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public updateMonatsBelegung$(requestParameters: KinderApiUpdateMonatsBelegungRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling updateMonatsBelegung$.');
        }
        const jaxMonatsBelegung = requestParameters.jaxMonatsBelegung;
        if (jaxMonatsBelegung === null || jaxMonatsBelegung === undefined) {
            throw new Error('Required parameter jaxMonatsBelegung was null or undefined when calling updateMonatsBelegung$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/monatsbelegung`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxMonatsBelegung,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public updateRechnungsaufteilung$(requestParameters: KinderApiUpdateRechnungsaufteilungRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public updateRechnungsaufteilung$(requestParameters: KinderApiUpdateRechnungsaufteilungRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public updateRechnungsaufteilung$(requestParameters: KinderApiUpdateRechnungsaufteilungRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public updateRechnungsaufteilung$(requestParameters: KinderApiUpdateRechnungsaufteilungRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling updateRechnungsaufteilung$.');
        }
        const jaxRechnungsAufteilungen = requestParameters.jaxRechnungsAufteilungen;
        if (jaxRechnungsAufteilungen === null || jaxRechnungsAufteilungen === undefined) {
            throw new Error('Required parameter jaxRechnungsAufteilungen was null or undefined when calling updateRechnungsaufteilung$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/rechnungsaufteilung`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxRechnungsAufteilungen,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * @param requestParameters
     * @param observe set whether to return the data Observable as the body, response or events. defaults to
     *     returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional configuration of the HttpClient.
     */
    public validateNewBelegung$(requestParameters: KinderApiValidateNewBelegungRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public validateNewBelegung$(requestParameters: KinderApiValidateNewBelegungRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public validateNewBelegung$(requestParameters: KinderApiValidateNewBelegungRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public validateNewBelegung$(requestParameters: KinderApiValidateNewBelegungRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const kindId = requestParameters.kindId;
        if (kindId === null || kindId === undefined) {
            throw new Error('Required parameter kindId was null or undefined when calling validateNewBelegung$.');
        }
        const jaxBelegung = requestParameters.jaxBelegung;
        if (jaxBelegung === null || jaxBelegung === undefined) {
            throw new Error('Required parameter jaxBelegung was null or undefined when calling validateNewBelegung$.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();
        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/kinder/${this.configuration.encodeParam({name: "kindId", value: kindId, in: "path", style: "simple", explode: false, dataType: "EntityId", dataFormat: "entity-id"})}/validate/belegungen`;
        const {basePath, withCredentials} = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: jaxBelegung,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
// @formatter:on
